import React from 'react';
import { Eye, CheckCircle, RefreshCw, Users } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const StatCard = ({ icon: Icon, label, value, sub, color, loading }) => (
  <div className={`rounded-2xl p-5 border ${color} flex items-start gap-4`}>
    <div className="p-2.5 rounded-xl bg-white/10 flex-shrink-0">
      <Icon className="w-5 h-5 text-white" />
    </div>
    <div className="min-w-0">
      <p className="text-xs font-medium text-white/60 uppercase tracking-wider mb-1">{label}</p>
      {loading ? (
        <div className="h-8 w-20 bg-white/10 rounded-lg animate-pulse" />
      ) : (
        <p className="text-2xl font-bold text-white leading-none">{value}</p>
      )}
      {sub && !loading && (
        <p className="text-xs text-white/50 mt-1">{sub}</p>
      )}
    </div>
  </div>
);

const PlaybackStatCards = ({ stats, loading }) => {
  const cards = [
    {
      icon: Eye,
      label: 'Total Views',
      value: stats?.totalViews?.toLocaleString() ?? '—',
      sub: 'All watch events',
      color: 'bg-violet-600/30 border-violet-500/30',
    },
    {
      icon: CheckCircle,
      label: 'Avg Completion Rate',
      value: stats?.avgCompletionRate != null ? `${stats?.avgCompletionRate}%` : '—',
      sub: 'Across all videos',
      color: 'bg-emerald-600/30 border-emerald-500/30',
    },
    {
      icon: RefreshCw,
      label: 'Total Rewatches',
      value: stats?.totalRewatches?.toLocaleString() ?? '—',
      sub: 'Replay events',
      color: 'bg-amber-600/30 border-amber-500/30',
    },
    {
      icon: Users,
      label: 'Unique Viewers',
      value: stats?.uniqueViewers?.toLocaleString() ?? '—',
      sub: 'Distinct users',
      color: 'bg-sky-600/30 border-sky-500/30',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards?.map(card => (
        <StatCard key={card?.label} {...card} loading={loading} />
      ))}
    </div>
  );
};

export default PlaybackStatCards;
